import React from "react"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { BorderedInfoBox } from "../../shared/BorderedInfoBox"

export function ThanksForUpdatingUsTile(): JSX.Element {
  return (
    <BorderedInfoBox>
      <Box
        display="flex"
        flexDirection="column"
        gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
        alignSelf="stretch"
      >
        <Typography variant="body1">
          <FormattedMessage defaultMessage="Thanks for updating us." />
        </Typography>
        <Typography variant="body1">
          <FormattedMessage defaultMessage="Your Care Team is reviewing your update. We'll notify you by email when your new Carrot Plan is ready." />
        </Typography>
      </Box>
    </BorderedInfoBox>
  )
}
